module.exports = __webpack_public_path__ + "static/media/courses.81c76218.svg";